export const COLLECTIONS_PATH = '/collections';
export const WORKBOOKS_PATH = '/workbooks';
